module.exports = __webpack_public_path__ + "assets/img/sai_hero.ac11a7ca.jpg";